import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['editor', 'replaceVoterInstructionsCheckbox'];

  declare editorTarget: HTMLElement;
  declare replaceVoterInstructionsCheckboxTarget: HTMLInputElement;

  connect() {
    this.element.addEventListener('quill:content-changed', this.handleQuillChange.bind(this))
  }

  private toggleEditVoterInstructions(): void {
    this.editorTarget.classList.toggle('hide');

    const quillEditor = this.editorTarget.querySelector('.ql-editor');
    if (quillEditor) {
      quillEditor.innerHTML = '';
    }
  }

  private handleQuillChange(event: CustomEvent): void {
    const { isEmpty } = event.detail

    if (isEmpty) {
      if (this.replaceVoterInstructionsCheckboxTarget.checked) {
        this.replaceVoterInstructionsCheckboxTarget.click()
      }
      this.replaceVoterInstructionsCheckboxTarget.disabled = true
    } else {
      this.replaceVoterInstructionsCheckboxTarget.disabled = false
    }
  }

  disconnect() {
    this.element.removeEventListener('quill:content-changed', this.handleQuillChange.bind(this))
  }
}
